// import { Box, Button, styled, Typography } from "@mui/material";
// import React from "react";
// import { useNavigate } from "react-router-dom";

// const StoryContent = styled(Typography)(() => ({
//   overflow: "hidden",
//   display: "-webkit-box",
//   WebkitBoxOrient: "vertical",
//   WebkitLineClamp: 3,
//   textOverflow: "ellipsis",
// }));

// export const StoryBox = ({ storyData }) => {
//   const navigate = useNavigate();

//   const handleReadMore = () => {
//     navigate(`/story-detail?id=${storyData.auto_id}`, {
//       state: storyData,
//     });
//   };

//   return (
//     <Box
//       px={2}
//       sx={{
//         cursor: "pointer",
//         maxWidth: { xs: "100%", sm: "360px" },
//         margin: "auto",
//       }}
//       onClick={handleReadMore}
//     >
//       <div className="storySec">
//         <img
//           src={storyData.images}
//           alt={`${storyData.bride} weds ${storyData.groom}`}
//           className="img-fluid"
//           style={{
//             width: "100%",
//             height: "294px",
//             borderRadius: "10%",
//             objectFit: "cover",
//           }}
//         />

//         <div className="styoryContent">
//           <Typography variant="h5">
//             {storyData.bride} weds {storyData.groom}
//           </Typography>

//           <StoryContent variant="body2">
//             {storyData.story}
//           </StoryContent>

//           <Button size="small">Read More</Button>
//         </div>
//       </div>
//     </Box>
//   );
// };






import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export const StoryBox = ({ storyData }) => {
  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate(`/story-detail?id=${storyData.auto_id}`, {
      state: storyData,
    });
  };

  const formatMonthYear = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        month: "short",
        year: "numeric",
      })
      .toUpperCase();
  };

  return (
    <Box
      onClick={handleReadMore}
      sx={{
        position: "relative",
        marginTop: "20px",
        height: "580px", // reduced height
        padding: "12px", // small white padding like figma

        borderRadius: "30px",
        backgroundColor: "#fff",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        cursor: "pointer",
        transition: "0.3s ease",
        "&:hover": {
          transform: "translateY(-6px)",
        },
      }}
    >
      {/* Top Image */}
      <Box
        component="img"
        src={storyData.images}
        alt={`${storyData.bride} weds ${storyData.groom}`}
        sx={{
          width: "100%",
          height: "407px",
          borderRadius: "20px 20px 0px 0px",
          objectFit: "cover",
        }}
      />

      {/* Gradient Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: "300px",
          height: "120px",

          left: 0,
          width: "100%",
          background:
            "linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.85))",
        }}
      />

      {/* Month Badge */}
      <Box
        sx={{
          position: "absolute",
          top: "25px",
          right: "25px",
          backgroundColor: "#fff",
          borderRadius: "50px",
          padding: "6px 14px",
          fontSize: "10px",
          fontWeight: 600,
          color: "#000",
          fontFamily: "Montserrat",
        }}
      >
        {formatMonthYear(storyData.marriage_date)}
      </Box>

      {/* Couple Name */}
      <Typography
        sx={{
          position: "absolute",
          top: "320px",
          left: "14px",
          fontSize: "27px",

          fontWeight: 600,
          color: "#fff",
          fontFamily: "Montserrat",
        }}
      >
        {storyData.bride} weds {storyData.groom}
      </Typography>

      {/* Description */}
      <Typography
        sx={{
          position: "absolute",
          top: "450px",
          left: "33px",
          width: "calc(100% - 66px)",
          fontSize: "16px",
          fontWeight: 500,
          lineHeight: "150%",
          color: "#4f4f4f",
          fontFamily: "Montserrat",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textAlign: "left",
        }}
      >
        “{storyData.story}”
      </Typography>

      {/* Read Full Story */}
      <Box
        sx={{
          position: "absolute",
          bottom: "25px",
          left: "33px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontSize: "14px",
          fontWeight: 600,
          color: "#e60000",
          fontFamily: "Montserrat",
        }}
      >
        Read Full Story
        <span style={{ fontSize: "16px" }}>→</span>
      </Box>
    </Box>
  );
};
